import { ActionTree } from "vuex";
import { api } from "@tt-app/api";
import {
  R,
  S,
  ReleaseNotesActions,
  ReleaseNotesMutationNames,
  ReleaseNotesActionNames
} from "@tt-app/types/releaseNotes/store";

export const releaseNotesActions: ActionTree<S, R> & ReleaseNotesActions = {
  async [ReleaseNotesActionNames.REQUEST_RELEASE_NOTES]({ commit }) {
    commit(ReleaseNotesMutationNames.SET_LOADING, true);
    try {
      // Only fetch the first page of release notes for now. Eventually, we will add pagination.
      const page = "1";
      const { data } = await api.releaseNotes.releaseNotes(page);
      commit(ReleaseNotesMutationNames.RELEASE_NOTES, data);
    } catch (error) {
      console.log(`${ReleaseNotesActionNames.REQUEST_RELEASE_NOTES} failed`, error);
    } finally {
      commit(ReleaseNotesMutationNames.SET_LOADING, false);
    }
  }
};
